import React, { Component } from "react";
import {
  Button,
  Drawer,
  Table,
  Row,
  Col,
  Input,
  Select,
  Space,
  PageHeader,
} from "antd";
import * as XLSX from "xlsx-js-style";
import moment from "moment";
import { connect } from "react-redux";
import {
  SearchOutlined,
  PlusOutlined,
  BarChartOutlined,
  UnorderedListOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import CreateModas from "./createModas";
import { LanguageContext } from "../../context/LanguageContext";
import { professionalAction } from "../../_actions";

const { Search } = Input;
const { Option } = Select;

class Modas extends Component {
  static contextType = LanguageContext;

  state = {
    heads: [],
    filteredHeads: [],
    isCreateModalVisible: false,
    loader: false,
    showList: "list",
    countList: false,
    dataList: [],
    searchText: "",
    selectedMainHead: undefined,
  };
  ModasoperandiHeadId = (id) => {
    this.setState({
      loader: true,
    });
    professionalAction.ModasoperandiHeadId(id).then((res) => {
      this.setState({
        dataList: res.data,
        loader: false,
      });
    });
  };

  openCountList = (id) => {
    this.setState({ countList: true }, () => {
      this.ModasoperandiHeadId(id);
    });
  };

  closeCountList = () => {
    this.setState({ countList: false });
  };

  ListModasoperandi = () => {
    this.setState({ loader: true });
    professionalAction.ListModasoperandi().then((res) => {
      this.setState({
        heads: res.data,
        filteredHeads: res.data,
        loader: false,
      });
    });
  };
  CountModasoperandiHeadWise = () => {
    this.setState({ loader: true });
    professionalAction.CountModasoperandiHeadWise().then((res) => {
      this.setState({
        heads: res.data,
        filteredHeads: res.data,
        loader: false,
      });
    });
  };

  componentDidMount() {
    if (this.state.showList === "list") {
      this.ListModasoperandi();
    }
  }

  showCreateModal = () => {
    this.setState({ isCreateModalVisible: true });
  };

  handleCloseModal = () => {
    this.setState({ isCreateModalVisible: false });
  };

  handleSearch = (value = "") => {
    const { heads, selectedMainHead } = this.state;
    const searchText = value.trim().toLowerCase();
    const filteredHeads = heads.filter(
      (item) =>
        (!selectedMainHead || item.main_head_type === selectedMainHead) &&
        (!searchText ||
          Object.values(item).join(" ").toLowerCase().includes(searchText)),
    );

    this.setState({
      filteredHeads,
      searchText: value,
    });
  };

  handleMainHeadFilter = (selectedMainHead) => {
    const { heads, searchText } = this.state;
    const normalizedSearch = searchText.trim().toLowerCase();
    const filteredHeads = heads.filter(
      (item) =>
        (!selectedMainHead || item.main_head_type === selectedMainHead) &&
        (!normalizedSearch ||
          Object.values(item)
            .join(" ")
            .toLowerCase()
            .includes(normalizedSearch)),
    );

    this.setState({ selectedMainHead, filteredHeads });
  };

  handleClear = () => {
    this.setState((prevState) => ({
      filteredHeads: prevState.heads,
      searchText: "",
      selectedMainHead: undefined,
    }));
  };

  handleExcelDownload = () => {
    const { filteredHeads, showList } = this.state;
    const { t } = this.context;

    if (!filteredHeads.length) return;

    const reportTitle = t("mapping_modus_operandi");
    const fileName = `${reportTitle}_${moment().format("DDMMMYYYY")}`;
    const arrData = filteredHeads.map((item, index) =>
      showList === "list"
        ? {
            [t("sr.no")]: index + 1,
            [t("title")]: item.main_head_type || "-",
            [t("sub_title")]: item.crimetype || "-",
          }
        : {
            [t("sr.no")]: index + 1,
            [t("title")]: item.main_head_type || "-",
            [t("count")]: item.total_count || 0,
          },
    );

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };
    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };
    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([]);
    const headers = Object.keys(arrData[0]);
    const totalCols = headers.length;
    const merges = [];

    XLSX.utils.sheet_add_aoa(worksheet, [[reportTitle]], { origin: "A1" });
    worksheet.A1.s = titleStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A2" });
    headers.forEach((_, columnIndex) => {
      const cell = XLSX.utils.encode_cell({ r: 1, c: columnIndex });
      if (worksheet[cell]) worksheet[cell].s = headerStyle;
    });

    const rows = arrData.map((row) => Object.values(row));
    XLSX.utils.sheet_add_aoa(worksheet, rows, { origin: "A3" });
    rows.forEach((row, rowIndex) => {
      row.forEach((_, columnIndex) => {
        const cell = XLSX.utils.encode_cell({
          r: rowIndex + 2,
          c: columnIndex,
        });
        if (worksheet[cell]) worksheet[cell].s = cellStyle;
      });
    });

    const footerRowIndex = rows.length + 5;
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;
    XLSX.utils.sheet_add_aoa(worksheet, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    worksheet[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", wrapText: true },
    };
    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });

    worksheet["!cols"] = headers.map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));
    worksheet["!rows"] = [{ hpt: 38 }, { hpt: 42 }];
    for (let rowIndex = 2; rowIndex < rows.length + 2; rowIndex += 1) {
      worksheet["!rows"][rowIndex] = { hpt: 44 };
    }
    worksheet["!rows"][footerRowIndex - 1] = { hpt: 28 };
    worksheet["!freeze"] = { ySplit: 2 };
    worksheet["!merges"] = merges;

    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  getShowList = (value) => {
    this.setState(
      {
        showList: value,
        searchText: "",
        selectedMainHead: undefined,
      },
      () => {
        if (value === "list") {
          this.ListModasoperandi();
        }
        if (value === "count") {
          this.CountModasoperandiHeadWise();
        }
      },
    );
  };
  render() {
    const { t } = this.context;
    const {
      isCreateModalVisible,
      filteredHeads,
      loader,
      showList,
      countList,
      dataList,
      selectedMainHead,
    } = this.state;
    const mainHeadOptions = [
      ...new Set(
        this.state.heads.map((item) => item.main_head_type).filter(Boolean),
      ),
    ];

    const Columns =
      showList === "list" || this.state.countList == true
        ? [
            {
              title: t("sr.no"),
              render: (_, __, index) => index + 1,
              width: 80,
            },
            {
              title: t("title"),
              dataIndex: "main_head_type",
            },
            {
              title: t("sub_title"),
              dataIndex: "crimetype",
            },
          ]
        : [
            {
              title: t("sr.no"),
              render: (_, __, index) => index + 1,
              width: 80,
            },
            {
              title: t("title"),
              dataIndex: "main_head_type",
            },
            {
              title: t("count"),
              dataIndex: "total_count",
              render: (text, record) => (
                <Button
                  onClick={() => {
                    this.openCountList(record.head_id);
                  }}
                  type="link"
                >
                  {text}
                </Button>
              ),
            },
          ];
    return (
      <div
        className="site-page-header-ghost-wrapper"
        style={{
          padding: "20px",
          background: "#fff",
          marginBottom: "20px",
        }}
      >
        <PageHeader title={t("mapping_modus_operandi")} />
        {/* Top Action Bar */}
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 16 }}
        >
          <Col>
            <Space>
              {/* Search */}
              <Search
                placeholder="Search..."
                allowClear
                enterButton={<SearchOutlined />}
                onSearch={this.handleSearch}
                onChange={(event) => this.handleSearch(event.target.value)}
                value={this.state.searchText}
                style={{ width: 250 }}
              />

              {showList === "list" && (
                <Select
                  placeholder={t("title")}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  value={selectedMainHead}
                  onChange={this.handleMainHeadFilter}
                  style={{ width: 220 }}
                >
                  {mainHeadOptions.map((mainHead) => (
                    <Option key={mainHead} value={mainHead}>
                      {mainHead}
                    </Option>
                  ))}
                </Select>
              )}
            </Space>
          </Col>

          <Col>
            <Space>
              {/* Clear Button */}
              {(this.state.searchText || selectedMainHead) && (
                <Button onClick={this.handleClear}>Clear</Button>
              )}

              <Button
                icon={<FileExcelOutlined />}
                onClick={this.handleExcelDownload}
                disabled={!filteredHeads.length}
              >
                Excel
              </Button>

              {/* Create Button */}
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={this.showCreateModal}
              >
                Map
              </Button>
            </Space>
          </Col>
        </Row>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            width: "100%",
            padding: "16px 0",
          }}
        >
          {/* View Type Selection */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              alignItems: "center",
              padding: "12px",
              background: "#f5f5f5",
              borderRadius: "8px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Button
                type={showList == "count" ? "primary" : "default"}
                onClick={() => this.getShowList("count")}
                icon={<BarChartOutlined />}
                style={{
                  minWidth: "120px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                {t("statistics")}
              </Button>

              <Button
                type={showList == "list" ? "primary" : "default"}
                onClick={() => this.getShowList("list")}
                icon={<UnorderedListOutlined />}
                style={{
                  minWidth: "120px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                {t("list")}
              </Button>
            </div>
          </div>
        </div>
        <div
          style={{
            width: "fit-content",
            height: 32,
            marginBottom: "16px",
            padding: "4px 12px",
            background: "#fff",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span style={{ color: "#666" }}>{t("total")}:</span>
          <span style={{ fontWeight: "bold" }}>{filteredHeads.length}</span>
        </div>

        {/* Table */}
        <Table
          loading={loader}
          rowKey={(record, index) => index}
          columns={Columns}
          dataSource={filteredHeads}
          pagination={{ showSizeChanger: true }}
        />
        <Drawer
          title="Modas"
          visible={countList}
          onClose={this.closeCountList}
          footer={null}
          width={600}
        >
          <Table
            loading={loader}
            rowKey={(record, index) => index}
            columns={Columns}
            dataSource={dataList}
            pagination={{ showSizeChanger: true }}
          />
        </Drawer>

        {/* Create Drawer */}
        <Drawer
          title="Create Modas"
          visible={isCreateModalVisible}
          onClose={this.handleCloseModal}
          footer={null}
          width={600}
        >
          <CreateModas
            close={this.handleCloseModal}
            ListModasoperandi={this.ListModasoperandi}
            getShowList={this.getShowList}
            data={filteredHeads}
          />
        </Drawer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;

  return {
    user,
    users,
    professionals,
  };
}

const connectedModas = connect(mapStateToProps)(Modas);
export { connectedModas as Modas };
